import { useContext } from "react";

import NoticeContext from "src/contexts/notices/NoticeContext";

/**
 * Returns notices and acknowledgement/dismissal controls from the nearest notice context.
 *
 * Postconditions: Uses context defaults without a provider; reading the context does not
 * acknowledge or dismiss a notice.
 */
const useNoticesContext = () => useContext(NoticeContext);

export default useNoticesContext;
